import { get, post, put } from "../Config";

//GET
export function SearchSlotList({ params }) {
  return get({ url: `/api/sb/v1/slot`,params});
}
